<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Add Brand</h4>
            <p v-if="!maxReached" class="category">You can add up to {{ brandSlotsRemaining }} more brands on your {{ accountData.authDetails.account.data.planName }} Plan.</p>
          </div>
          <div class="card-content">
            <p v-if="maxReached" class="text-danger">Please upgrade your Authentic.net plan if you wish to add more brands.</p>
            <form v-if="!maxReached" method="get" action="/" v-on:submit.prevent class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Name</label>
                  <div class="col-sm-10">
                    <input type="text" name="title" v-model="newBrand.name" v-validate="modelValidations.name" class="form-control" />
                    <small class="text-danger" v-show="name.invalid">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Image</label>
                  <div class="col-sm-10">
                    <input type="file" name="imageFile" ref="imageFile" accept="image/*" @change="selectFile" />
                    <input v-show="false" type="text" name="logoUrl" v-model="newBrand.logoUrl" v-validate="modelValidations.logoUrl"  class="form-control" />
                    <small class="text-danger" v-show="logoUrl.invalid">
                      {{ getError('logoUrl') }}
                    </small>
                    <p-progress :value="uploadProgress" type="info"></p-progress>
                  </div>
                </div>
              </fieldset>

              <button type="submit" v-if="!loading" @click.prevent="validateAddBrand()" class="btn btn-fill btn-info">Submit</button>
              <button type="button" v-if="loading" class="btn btn-wd btn-info" disabled="disabled">
                <span class="btn-label">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
                Submit
              </button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>

    <div class="row">
      <div v-for="brand in brandsTable" class="col-lg-3" :key="brand.key">
        <div class="card" style="padding-top:10px;">
          <div class="text-center">
            <h3>{{brand.name}}</h3>
          </div>
          <div class="text-center" style="height: 140px; display: flex; align-items: center;">
            <div class="img-container">
              <img v-if="brand.logoUrl" :src="brand.logoUrl" :alt="brand.name">
              <span v-if="!brand.logoUrl">{NO BRAND LOGO}</span>
            </div>
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <button type="button" v-if="!brand.isArchived && !brand.deleting" @click.prevent="deleteBrand(brand)" class="btn btn-fill btn-danger btn-sm">Delete</button>
            <button type="button" v-if="!brand.isArchived && brand.deleting" class="btn btn-danger btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Deleting...
            </button>
            <button type="button" v-if="brand.isArchived && !brand.unarchiving" @click.prevent="unArchiveBrand(brand)" class="btn btn-fill btn-sm">Un-Archive</button>
            <button type="button" v-if="brand.unarchiving" class="btn btn-fill btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Un-Archiving...
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 pull-right">
        <div style="float: right;">
          <p class="category">Show Archived Brands</p>
          <p-switch v-model="showArchived" type="primary" on-text="ON" off-text="OFF"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {Table, TableColumn} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  // import firebase from 'firebase'
  // var storageRef = firebase.storage().ref()
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch,
      PProgress
    },
    mixins: [toolboxMixin],
    props: ['accountData'],
    computed: {
      ...mapFields(['logoUrl',
        'name']),
      maxReached () {
        let reached = this.accountData.authDetails.account.data.planUsageQtyBrands >= this.accountData.authDetails.account.data.planConstraints.maxBrands
        return reached
      },
      brandSlotsRemaining () {
        let maxBrands = this.accountData.authDetails.account.data.planConstraints.maxBrands
        let qtyBrands = this.accountData.authDetails.account.data.planUsageQtyBrands
        let remaining = maxBrands - qtyBrands
        remaining = Math.max(remaining, 0)
        return remaining
      }
    },
    data () {
      return {
        user: {
          email: '',
          token: ''
        },
        newBrand: {
          logoUrl: '',
          name: ''
        },
        imageFile: '',
        uploadProgress: 0,
        loading: false,
        modelValidations: {
          logoUrl: {
            required: true,
            url: true
          },
          name: {
            required: true
          }
        },
        brandsTable: [],
        brandIdIndexMap: new Map(),
        selects: {
          simple: '',
          multiple: 'ARS'
        },
        showArchived: false
      }
    },
    methods: {
      init () {
        this.getCurrentUser().then(result => {
          this.user = result
          this.getBrands()
        })
      },
      selectFile () {
        this.imageFile = this.$refs.imageFile.files[0]
        this.uploadFile()
      },
      uploadFile () {
        this.loading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`brands/${filename}`).put(this.imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.uploadProgress = progress
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.loading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              console.log('File available at', downloadURL)
              this.newBrand.logoUrl = downloadURL
              this.loading = false
            })
          })
      },
      async archiveBrand (brand) {
        await db.collection('brands').doc(brand.id).update({ isArchived: true })
        this.showNotify(`Brand ${brand.name} archived.`, 'success', 'Success')
        this.getBrands()
      },
      async unArchiveBrand (brand) {
        brand.unarchiving = true
        await db.collection('brands').doc(brand.id).update({ isArchived: false })
        brand.key = this.$uuid.v4()
        brand.unarchiving = false
        this.showNotify(`Brand ${brand.name} un-archived.`, 'success', 'Success')
        this.getBrands()
      },
      getBrands () {
        this.brandsTable = []
        this.brandIdIndexMap = new Map()
        let ref = db.collection('brands').where('accountId', '==', this.user.accountId)
        ref.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            if (change.type === 'added') {
              let doc = change.doc
              // console.log('isArchived', doc.data().isArchived)
              if (this.showArchived || doc.data().isArchived !== true) {
                let data = {
                  id: doc.id,
                  name: doc.data().name,
                  logoUrl: await this.brandImgUrl(doc.id, doc.data(), '140x140'),
                  key: this.$uuid.v4(),
                  isArchived: doc.data().isArchived
                }
                this.brandsTable.push(data)
                this.brandIdIndexMap.set(doc.id, this.brandsTable.length - 1)
              }
            }
          })
        })
      },
      addBrand () {
        let brand = {
          name: this.newBrand.name,
          logoUrl: this.newBrand.logoUrl,
          accountId: this.user.accountId,
          qtyValidations: 0,
          qtyRegistrations: 0
        }
        db.collection('brands').add(brand).then(response => {
          this.loading = false
        })
        .catch(err => {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        })
      },
      validateAddBrand () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.addBrand()
          } else {
            this.loading = false
          }
        })
      },
      async deleteBrand (brand) {
        try {
          let brandId = brand.id
          brand.deleting = true
          brand.key = this.$uuid.v4()
          let data = {}
          data.userToken = await firebase.auth().currentUser.getIdToken()
          data.accountId = this.user.accountId
          data.brandId = brandId
          let accountDeleteBrand = firebase.functions().httpsCallable('accountDeleteBrand')
          let result = await accountDeleteBrand(data)
          brand.deleting = false
          brand.key = this.$uuid.v4()
          this.showNotify(`Brand ${brand.name} deleted.`, 'success', 'Success')
          this.brandsTable.splice(this.brandIdIndexMap.get(brandId), 1)
        } catch (err) {
          brand.deleting = false
          brand.key = this.$uuid.v4()
          swal.fire({
            title: 'Cannot Be Deleted',
            text: `This brand cannot be deleted as it contains existing Authentic.net codes. Would you like to archive it instead?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-info btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, archive it!',
            buttonsStyling: false
          }).then(async (result) => {
            if (result.value) await this.archiveBrand(brand)
          })
        }
      },
      isDeleting (brand) {
        return brand.deleting
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      }
    },
    watch: {
      showArchived: function (newFrom, oldFrom) {
        this.getBrands()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.img-container {
  max-width: 140px;
  max-height: 140px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Brands.vue